import {formatMoney} from '@shopify/theme-currency';

const selectors = {
  price: 'data-header-cart-price',
  count: 'data-header-cart-count',
  dot: 'data-header-cart-full',
};

class Totals {
  constructor(el) {
    this.section = el;
    this.counts = this.section.querySelectorAll(`[${selectors.count}]`);
    this.prices = this.section.querySelectorAll(`[${selectors.price}]`);
    this.dots = this.section.querySelectorAll(`[${selectors.dot}]`);
    this.cart = null;
    this.listen();
  }

  listen() {
    document.addEventListener(
      'theme:cart:change',
      function (event) {
        this.cart = event.detail.cart;
        this.update();
      }.bind(this)
    );
  }

  update() {
    if (this.cart) {
      this.prices.forEach((price) => {
        price.setAttribute(selectors.price, this.cart.total_price);
        const newTotal = formatMoney(this.cart.total_price, theme.moneyFormat);
        price.innerHTML = newTotal;
      });
      this.counts.forEach((count) => {
        count.setAttribute(selectors.count, this.cart.item_count);
        count.innerHTML = `(${this.cart.item_count})`;
      });
      this.dots.forEach((dot) => {
        const full = this.cart.item_count > 0;
        dot.setAttribute(selectors.dot, full);
      });
    }
  }
}
const headerTotals = {
  onLoad() {
    new Totals(this.container);
  },
};

export default headerTotals;
